import type { CosignatureQueueItem } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";
import { isCosignatureStatus } from "@/core/helpers/(predicates)/cosignature";

import { DocumentTypeMap } from "../constants";

export function adaptQueueData(items: CosignatureQueueItem[]) {
  // dev-era artifacts (e.g. "published") can leak into responses — drop rows
  // with a status outside the known enum rather than crash on an unmapped badge/action
  return items
    .filter((item) => isCosignatureStatus(item.cosignature_status))
    .map((item) => ({
      dateSigned: item.signature_date ? dayjs(item.signature_date).format("MM/DD/YYYY") : null,
      daysPending: item.signature_date ? dayjs().diff(dayjs(item.signature_date), "day") : null,
      documentType: item.document_type,
      id: item.document_id,
      patientId: item.patient_id,
      patientName: item.patient_name,
      relatedNoteId: item.related_note_id ?? null,
      // raw ISO string used for correct date sort (dateSigned is MM/DD/YYYY, not lexicographically sortable)
      signatureDate: item.signature_date ?? null,
      status: item.cosignature_status,
      submittedBy: item.provider_name,
      type: DocumentTypeMap[item.document_type],
    }));
}

export type AdaptedQueueRow = ReturnType<typeof adaptQueueData>[number];
